__turbopack_context__.v({
  "className": "inter_tight_5d7b0206-module__6Aeo6G__className",
});
